import * as React from 'react';
import styled from 'styled-components';
import Link from './Link';
import Media from './media';
import { LandingSinglePageTitle } from '../styles/Typography';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem 2rem;
  margin-top: 1rem;
  padding-bottom: var(--footerHeight);

  @media (min-width: 860px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const SinglePageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const PageDescription = styled.p`
  text-align: center;
  margin: 0;
  margin-bottom: 2rem;
`;

const StyledLink = styled(Link)`
  margin-top: auto;
`;

const PlainLink = styled.a`
  width: fit-content;
  margin-bottom: 15px;
  &:hover {
    box-shadow: 0 2px 0 var(--mainNeutral);
  }
`;

const AdditionalLinksBox = styled.div`
  display: flex;
  flex-direction: column;
  grid-column-start: 1;
  align-items: center;

  @media (min-width: 860px) {
    grid-column-end: 3;
    align-items: flex-start;
  }
`;

function SinglePage({ page }) {
  return (
    <SinglePageContainer>
      <Media videoSrc={page.videoSrc} image={page.image} />
      <LandingSinglePageTitle>{page.title}</LandingSinglePageTitle>
      <PageDescription>{page.description}</PageDescription>
      <StyledLink to={`/demos/${page.slug.current}`} text="Learn more" />
    </SinglePageContainer>
  );
}

export default function DemoPagesList({ demoPages }) {
  return (
    <Container className="mainCenteredContent">
      {demoPages.map(demoPage => (
        <SinglePage key={demoPage._id} page={demoPage} />
      ))}
      <AdditionalLinksBox>
        <PlainLink href="demos-custom/index/" target="_blank" rel="noopener noreferrer">
          Additional demos
        </PlainLink>
      </AdditionalLinksBox>
    </Container>
  );
}
